<template>
<div>
    <Breadcrumbs main="Procuremnet" submain="GRN" title="View" />
    <!-- Container-fluid starts-->

    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <div style="display: flex; justify-content: flex-end;">
                                <b-button variant="primary" class="mb-4" @click="openReturnModal">Raise Return</b-button>
                            </div> 
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>GRN Number</label>
                                        <span class="form-control">{{ grn.grn_number }}</span>
                                    </div>
                                </div>
                               <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Purchase Order</label>
                                        <router-link :to="`/procurement/purchase-order/${grn.purchase_order}`" v-if="grn.purchase_order">
                                            <span class="form-control">{{ grn.purchase_order_number }}</span>
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Received By</label>
                                        <span class="form-control">{{ grn.received_by_name }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group" >
                                        <label>Received Date</label>
                                        <span class="form-control">{{ grn.received_date }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="table-responsive datatable-vue mt-4" v-if="grn.purchase_order_number && grn.items && grn.items.length > 0">
                                <b-table show-empty stacked="md" :items="grn.items" :fields="tablefields" small>
                                    <!-- Index -->
                                    <template #cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>
                                    <!-- Item Name -->
                                    <template #cell(name)="data">
                                        {{ data.item.po_item_name }}
                                    </template>
                                </b-table>
                            </div>
                            <!-- <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Items</label>
                                        <ItemTable style="margin-bottom: 10px;" id="item-table" @itemsUpdated="updateItems" />
                                    </div>
                                </div>
                            </div> -->
                            <div class="row mt-3">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Notes</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter note..." rows="2" v-model="grn.notes" disabled></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <!-- <button @click="onSubmit" class="btn btn-success mr-3" :disabled="isDisabled">Update</button> -->
                                        <router-link to="/procurement/grn">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style="margin-top: 52px;" v-if="return_by_grn && return_by_grn.length > 0">
                            <h6>Purchase Returns</h6>
                            <div class="table-responsive datatable-vue" style="margin-top: 22px;">
                                <b-table show-empty stacked="md" :items="return_by_grn" :fields="tablefields_return">
                                    <template #cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>
                                     <template #cell(grn)="data">
                                        <router-link :to="`/procurement/edit-grn/${data.item.grn?.id }`" class="link-style">
                                            {{ data.item.grn?.grn_number }}
                                        </router-link>
                                        
                                    </template>
                                    
                                    
                                    <template #cell(created_by)="data">
                                        <div style="max-width: 250px;">
                                            {{ data.item.created_by?.username }}
                                        </div>
                                        <div class="d-flex flex-column" v-if="data.item.created_at">
                                            <small class="">Created At: {{ getDate(data.item.created_at) }}</small>
                                        </div>
                                    </template>
                                    <template #cell(confirmed_by)="data">
                                       <div v-if="data.item.confirmed_by">
                                            <div style="max-width: 250px;">
                                                {{ data.item.confirmed_by?.username }}
                                            </div>
                                            <div class="d-flex flex-column" v-if="data.item.confirmed_at">
                                                <small class="">Confirmed At: {{ getDate(data.item.confirmed_at) }}</small>
                                            </div>
                                       </div>
                                    </template>
                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <feather v-if="data.item.status == 'draft'" type="delete" size="20px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteReturn(data.item.id)" title="Delete"></feather>
                                            <router-link :to="`/procurement/purchase-return/${data.item.id}`" >
                                                <feather type="eye" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="View"></feather>
                                            </router-link> 
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>

    <b-modal id="modal-raise-return-center" ref="modal" title="Raise Return" size="lg" @ok="handleReturnOk">
        <textarea class="form-control mb-3" placeholder="Enter return reason..." rows="3" v-model="reason"></textarea>
        <div class="table-responsive datatable-vue mt-4" v-if="return_items && return_items.length > 0">
            <b-table show-empty stacked="md" :items="return_items" :fields="tablefields_return_modal" small>
                <!-- Index -->
                <template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
                <!-- Item Name -->
                <template #cell(name)="data">
                    {{ data.item.po_item_name }}
                </template>
                <!-- Editable Quantity -->
                <template #cell(quantity_received)="data">
                    <input type="number" class="form-control" v-model.number="data.item.quantity_received" min="0" />
                </template>
                <template #cell(actions)="data">
                    <b-button 
                        variant="danger" 
                        size="sm" 
                        @click="removeReturnItem(data.index)"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
        </div>
    </b-modal>

    <!-- Purchase Return Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this purchase return?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    computed
} from "vue";
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import ItemTable from "./item-table.vue";
import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import moment from "moment";
export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        ItemTable,
        Multiselect,
        'v-select': vSelect
    },

    data() {
        return {
            return_items: [],
            reason: '',
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Item Name'
                },
                {
                    key: 'po_item_unit',
                    label: 'Item Unit'
                },
                {
                    key: 'quantity_ordered',
                    label: 'Quantity Ordered'
                },
                {
                    key: 'quantity_received',
                    label: 'Quantity Received'
                },
                { key: "actions", label: "" }
            ],
            tablefields_return_modal: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Item'
                },
                {
                    key: 'quantity_ordered',
                    label: 'Quantity Ordered'
                },
                {
                    key: 'quantity_received',
                    label: 'Quantity Return'
                },
                { key: "actions", label: "" }
            ],
            tablefields_return: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'return_number',
                    label: 'Return No',
                    sortable: true
                },
                {
                    key: 'grn',
                    label: 'GRN No',
                    sortable: true
                },
                {
                    key: 'reason',
                    label: 'Reason',
                    sortable: true
                },
                {
                    key: 'created_by',
                    label: 'Created By',
                    sortable: false
                },
                {
                    key: 'confirmed_by',
                    label: 'Confirmed By',
                    sortable: false
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                },
            ],
            editor: ClassicEditor,
            isDisabled: false,
            grn: {
                grn_number: null,
                purchase_order: null,
                purchase_order_number: null,
                received_by_name: null,
                received_date: null,
                notes: '',
                items: []
            },
            delete_value: null
        }
    },

    computed: {
        ...mapState({
            detail :  state => state.grn.grn_detail,
            return_by_grn: state => state.purchaseReturn.return_by_grn
        })
    },

    watch: {
        detail:{
            handler(newVal){
                this.grn.grn_number = newVal.grn_number,
                this.grn.purchase_order = newVal.purchase_order,
                this.grn.purchase_order_number = newVal.purchase_order_number,
                this.grn.received_by_name = newVal.received_by_name,
                this.grn.received_date = newVal.received_date,
                this.grn.notes = newVal.notes
                this.grn.items = newVal.items
            },
        }
    },

    mounted() {
        this.grn.received_date = moment().format("YYYY-MM-DD");
        this.$store.dispatch("grn/fetchGRNDetail" , this.$route.params.id)
        this.$store.dispatch("purchaseReturn/fetchPurchaseReturnBY_GRN" , this.$route.params.id)
    },

    methods: {
        getDate(date) {
            return moment(String(moment(date))).format("YYYY-MM-DD")
        },
        
        openReturnModal() {
            this.return_items = this.grn.items.map(item => ({ ...item })); // shallow copy
            this.$bvModal.show("modal-raise-return-center");
        },

        removeReturnItem(index) {
            this.return_items.splice(index, 1);
        },

        handleReturnOk(bvModalEvent) {
            bvModalEvent.preventDefault(); 

            const items = this.return_items
                .filter(item => item.quantity_received > 0) 
                .map(item => ({
                    grn_item: item.id,
                    quantity_returned: item.quantity_received
                }));

            if (!this.reason) {
                Swal.fire({
                    title: "Warning!",
                    text: "Please enter a return reason.",
                    icon: "warning"
                });
                return;
            }

            if (items.length === 0) {
                Swal.fire({
                    title: "Warning!",
                    text: "Please enter quantity for at least one item.",
                    icon: "warning"
                });
                return;
            }

            const payload = {
                grn: this.$route.params.id,
                reason: this.reason,
                items
            };

            this.submitReturn(payload);
        },

        async submitReturn(payload) {
            this.$store.dispatch("purchaseReturn/addPurchaseReturn", {
            return: payload,
            from_details: true,
            grn_id: this.$route.params.id
        }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.reason = ''
                    this.$refs.modal.hide()
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        deleteReturn(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("purchaseReturn/deletePurchaseReturn", {
                delete: this.delete_value,
                from_details: true,
                grn_id: this.$route.params.id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },



        updateItems(data) {
            if (data) {
                this.requisition.items = data;
            }
        },

        onSubmit() {
            this.isDisabled = true,
                this.$store.dispatch("grn/updateGRN", this.grn).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.grn.purchase_order = null
                        this.grn.notes = []
                        this.grn.items = null

                        setTimeout(() => this.$router.push('/procurement/grn'), 2000)

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })

            this.isDisabled = false
        }
    }
};
</script>
